import * as React from "react";
import { Fragment, useState } from "react";
import ProductAccordionContentStyle1 from "./content/ProductAccordionContentStyle1";
import ProductAccordionContentStyle5 from "./content/ProductAccordionContentStyle5";
import ProductAccordionContentStyle4 from "./content/ProductAccordionContentStyle4";
import ProductAccordionContentStyle3 from "./content/ProductAccordionContentStyle3";
import ProductAccordionContentStyle2 from "./content/ProductAccordionContentStyle2";
import ProductImageCarousel from "./content/ProductImageCarousel";
import ProductAccordionContentStyleComponents from "./content/ProductAccordionContentStyleComponents";
import TextWithLinksParser from "../TextWithLinksParser/TextWithLinksParser";

export default function ProductAccordionItem({ itemData }) {
  const [isOpen, setIsOpen] = useState(!itemData.collapsed);

  const toggleBlock = (status) => {
    setIsOpen(!status);
  };

  return (
    itemData.title && (
      <div className={`accordion-item ${isOpen ? "active" : ""}`}>
        <div
          className={`accordion-item-title`}
          onClick={() => {
            toggleBlock(isOpen);
          }}
        >
          <div className="title-info">
            <h2>
              <span>{itemData.label}</span>
              <span className="collapse-indicator">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="13"
                  height="8.527"
                  viewBox="0 0 13 8.527"
                >
                  <path
                    d="M1 0a.941.941 0 0 0-.616 1.667L6.141 6.6.384 11.53a.941.941 0 1 0 1.222 1.424L8.2 7.314a.941.941 0 0 0 0-1.432L1.606.237A.94.94 0 0 0 1 0z"
                    transform="rotate(-90 4.264 4.263)"
                  />
                </svg>
              </span>
            </h2>
            <h3 dangerouslySetInnerHTML={{ __html: itemData.title }}></h3>
          </div>
        </div>

        <div className={`accordion-item-content`}>
          <div className={`accordion-content-block-wrapper ${itemData.style}`}>
            {itemData.description && (
              <p className={`item-description`}>
                <TextWithLinksParser text={itemData.description} />
              </p>
            )}
            {itemData.map && (
              <div className={`product-item-location-map`}>
                <img src={itemData.map} alt="" />
              </div>
            )}
            {itemData.info.map((infoBlock, itemIndex) => {
              return (
                !!Object.keys(infoBlock)?.length && (
                  <Fragment key={itemIndex}>
                    {itemData.style === "style_1" && (
                      <ProductAccordionContentStyle1
                        infoBlock={infoBlock}
                        itemIndex={itemIndex}
                      />
                    )}
                    {itemData.style === "style_2" && (
                      <ProductAccordionContentStyle2
                        itemIndex={itemIndex}
                        infoBlock={infoBlock}
                      />
                    )}
                    {itemData.style === "style_3" && (
                      <ProductAccordionContentStyle3 infoBlock={infoBlock} />
                    )}
                    {itemData.style === "style_4" && (
                      <ProductAccordionContentStyle4 infoBlock={infoBlock} />
                    )}
                    {itemData.style === "style_5" && (
                      <ProductAccordionContentStyle5 infoBlock={infoBlock} />
                    )}
                    {itemData.style === "style_components" && (
                      <ProductAccordionContentStyleComponents
                        infoBlock={infoBlock}
                      />
                    )}
                  </Fragment>
                )
              );
            })}
            {itemData.image_carousel && itemData.image_carousel.length > 0 && (
              <ProductImageCarousel
                productImageList={itemData.image_carousel}
              ></ProductImageCarousel>
            )}
          </div>
        </div>
      </div>
    )
  );
}
